import { RouteObject } from 'react-router-dom';
import Bookmark from '../../Pages/Application/Bookmark/Bookmark';
import Calender from '../../Pages/Application/Calender/Calender';
import GroupChat from '../../Pages/Application/Chat/GroupChat/GroupChat';
import PrivateChat from '../../Pages/Application/Chat/PrivateChat/PrivateChat';
import Contacts from '../../Pages/Application/Contacts/Contacts';
import AddProduct from '../../Pages/Application/Ecommerce/AddProduct/AddProduct';
import Cart from '../../Pages/Application/Ecommerce/Cart/Cart';
import Checkout from '../../Pages/Application/Ecommerce/Checkout/Checkout';
import InvoiceOne from '../../Pages/Application/Ecommerce/Invoices/Invoice-1/Invoice-1';
import InvoiceTwo from '../../Pages/Application/Ecommerce/Invoices/Invoice-2/Invoice-2';
import InvoiceThree from '../../Pages/Application/Ecommerce/Invoices/Invoice-3/Invoice-3';
import InvoiceFour from '../../Pages/Application/Ecommerce/Invoices/Invoice-4/Invoice-4';
import InvoiceFive from '../../Pages/Application/Ecommerce/Invoices/Invoice-5/Invoice-5';
import InvoiceSix from '../../Pages/Application/Ecommerce/Invoices/Invoice-6/Invoice-6';
import OrderHistory from '../../Pages/Application/Ecommerce/OrderHistory/OrderHistory';
import PaymentDetails from '../../Pages/Application/Ecommerce/PaymentDetails/PaymentDetails';
import Pricing from '../../Pages/Application/Ecommerce/Pricing/Pricing';
import ProductList from '../../Pages/Application/Ecommerce/ProductList/ProductList';
import ProductPage from '../../Pages/Application/Ecommerce/ProductPage/ProductPage';
import Products from '../../Pages/Application/Ecommerce/Products/Products';
import WishList from '../../Pages/Application/Ecommerce/WishList/WishList';
import LetterBox from '../../Pages/Application/Email/LetterBox/LetterBox';
import FileManager from '../../Pages/Application/FileManager/FileManager';
import ProjectCreate from '../../Pages/Application/Project/ProjectCreate/ProjectCreate';
import ProjectList from '../../Pages/Application/Project/ProjectList/ProjectList';
import SearchResult from '../../Pages/Application/SearchResult/SearchResult';
import SocialApp from '../../Pages/Application/SocialApp/SocialApp';
import Tasks from '../../Pages/Application/Tasks/Tasks';
import Todo from '../../Pages/Application/Todo/Todo';
import EditProfile from '../../Pages/Application/Users/EditProfile/EditProfile';
import UserCards from '../../Pages/Application/Users/UserCards/UserCards';
import UsersProfile from '../../Pages/Application/Users/UsersProfile/UsersProfile';
import BasicCard from '../../Pages/BonusUi/BasicCard/BasicCard';
import Breadcrumb from '../../Pages/BonusUi/Breadcrumb/Breadcrumb';
import CreativeCard from '../../Pages/BonusUi/CreativeCard/CreativeCard';
import Dropzone from '../../Pages/BonusUi/Dropzone/Dropzone';
import ImageCropper from '../../Pages/BonusUi/ImageCropper/ImageCropper';
import Carousel from '../../Pages/BonusUi/Carousel/Carousel';
import Pagination from '../../Pages/BonusUi/Paginations/Paginations';
import RangeSlider from '../../Pages/BonusUi/RangeSlider/RangeSlider';
import Rating from '../../Pages/BonusUi/Rating/Rating';
import Ribbons from '../../Pages/BonusUi/Ribbons/Ribbons';
import Scrollable from '../../Pages/BonusUi/Scrollable/Scrollable';
import SweetAlert from '../../Pages/BonusUi/SweetAlert/SweetAlert';
import Timeline from '../../Pages/BonusUi/Timeline/Timeline';
import Toast from '../../Pages/BonusUi/Toast/Toast';
import Tour from '../../Pages/BonusUi/Tour/Tour';
import TreeView from '../../Pages/BonusUi/TreeView/TreeView';
import ButtonGroup from '../../Pages/Buttons/ButtonGroup/ButtonGroup';
import DefaultStyle from '../../Pages/Buttons/DefaultStyle/DefaultStyle';
import ApexChart from '../../Pages/Charts/Apexchart/ApexChart';
import ChartJs from '../../Pages/Charts/ChartJs/ChartJs';
import GoogleChart from '../../Pages/Charts/GoogleChart/GoogleChart';
import Default from '../../Pages/Dashboard/Default/Default';
import Ecommerce from '../../Pages/Dashboard/Ecommerce/Ecommerce';
import Project from '../../Pages/Dashboard/Project/Project';
import BaseInput from '../../Pages/Forms/FormsControl/BaseInput/BaseInput';
import FormsValidation from '../../Pages/Forms/FormsControl/FormsValidation/FormsValidation';
import InputGroup from '../../Pages/Forms/FormsControl/InputGroup/InputGroup';
import InputMask from '../../Pages/Forms/FormsControl/InputMask/InputMask';
import MegaOption from '../../Pages/Forms/FormsControl/MegaOption/MegaOption';
import RadioCheckbox from '../../Pages/Forms/FormsControl/RadioCheckbox/RadioCheckbox';
import FormWizardOne from '../../Pages/Forms/FormsLayout/FormWizardOne/FormWizardOne';
import FormWizardTwo from '../../Pages/Forms/FormsLayout/FormWizardTwo/FormWizardTwo';
import TwoFactor from '../../Pages/Forms/FormsLayout/TwoFactor/TwoFactor';
import ClipBoard from '../../Pages/Forms/FormsWidgets/ClipBoard/ClipBoard';
import DatePicker from '../../Pages/Forms/FormsWidgets/DatePicker/DatePicker';
import Switch from '../../Pages/Forms/FormsWidgets/Switch/Switch';
import TouchSpin from '../../Pages/Forms/FormsWidgets/TouchSpin/TouchSpin';
import Typeahead from '../../Pages/Forms/FormsWidgets/Typeahead/Typeahead';
import FeatherIcons from '../../Pages/Icons/FeatherIcons';
import FlagIcons from '../../Pages/Icons/FlagIcons';
import FontAwesomeIcon from '../../Pages/Icons/FontAwesomeIcon';
import ICOIcon from '../../Pages/Icons/ICOIcon';
import ThemifyIcons from '../../Pages/Icons/ThemifyIcons';
import WhetherIcon from '../../Pages/Icons/WhetherIcons';
import AddPost from '../../Pages/Miscellaneous/Blog/AddPost/AddPost';
import BlogDetails from '../../Pages/Miscellaneous/Blog/BlogDetails/BlogDetails';
import BlogSingle from '../../Pages/Miscellaneous/Blog/BlogSingle/BlogSingle';
import AceEditor from '../../Pages/Miscellaneous/Editor/AceEditor/AceEditor';
import CkEditor from '../../Pages/Miscellaneous/Editor/CkEditor/CkEditor';
import MdeEditor from '../../Pages/Miscellaneous/Editor/MdeEditor/MdeEditor';
import Faq from '../../Pages/Miscellaneous/Faq/Faq';
import GalleryGrid from '../../Pages/Miscellaneous/Gallery/GalleryGrid/GalleryGrid';
import GalleryGridDesc from '../../Pages/Miscellaneous/Gallery/GalleryGridDesc/GalleryGridDesc';
import HoverEffect from '../../Pages/Miscellaneous/Gallery/HoverEffect/HoverEffect';
import MasonryGallery from '../../Pages/Miscellaneous/Gallery/MasonryGallery/MasonryGallery';
import MasonryImageDesc from '../../Pages/Miscellaneous/Gallery/MasonryImageDesc/MasonryImageDesc';
import CardView from '../../Pages/Miscellaneous/JobSearch/CardView/CardView';
import JobApply from '../../Pages/Miscellaneous/JobSearch/JobApply/JobApply';
import JobDetails from '../../Pages/Miscellaneous/JobSearch/JobDetails/JobDetails';
import ListView from '../../Pages/Miscellaneous/JobSearch/ListView/ListView';
import Knowledgebase from '../../Pages/Miscellaneous/Knowledgebase/Knowledgebase';
import DetailsCourse from '../../Pages/Miscellaneous/Learning/DetailsCourse/DetailsCourse';
import LearningList from '../../Pages/Miscellaneous/Learning/LearningList/LearningList';
import GoogleMap from '../../Pages/Miscellaneous/Maps/GoogleMap/GoogleMap';
import LeafletMaps from '../../Pages/Miscellaneous/Maps/LeafletMaps/LeafletMaps';
import SupportTicket from '../../Pages/Miscellaneous/SupportTicket/SupportTicket';
import HideNavScrollContainer from '../../Pages/PageLayout/HideNavScrollContainer/HideNavScrollContainer';
import SamplePage from '../../Pages/SamplePage/SamplePage';
import AdvanceInit from '../../Pages/Tables/DataTables/AdvanceInit/AdvanceInit';
import ApiDataTable from '../../Pages/Tables/DataTables/ApiDataTable/ApiDataTable';
import BasicInit from '../../Pages/Tables/DataTables/BasicInit/BasicInit';
import DataSource from '../../Pages/Tables/DataTables/DataSource/DataSource';
import BasicTable from '../../Pages/Tables/ReactstrapTable/BasicTable/BasicTable';
import TableComponent from '../../Pages/Tables/ReactstrapTable/TableComponent/TableComponent';
import Accordion from '../../Pages/Ui-Kits/Accordion/Accordion';
import Alert from '../../Pages/Ui-Kits/Alert/Alert';
import Avatars from '../../Pages/Ui-Kits/Avatars';
import Dropdown from '../../Pages/Ui-Kits/Dropdown/Dropdown';
import Grid from '../../Pages/Ui-Kits/Grid/Grid';
import HelperClasses from '../../Pages/Ui-Kits/HelperClasses';
import Lists from '../../Pages/Ui-Kits/Lists/Lists';
import Modal from '../../Pages/Ui-Kits/Modal/Modal';
import Popover from '../../Pages/Ui-Kits/Popover/Popover';
import Progress from '../../Pages/Ui-Kits/Progress/Progress';
import ReactstrapTabs from '../../Pages/Ui-Kits/Tabs/ReactstrapTabs';
import TagAndPills from '../../Pages/Ui-Kits/TagAndPills/TagAndPills';
import Tooltip from '../../Pages/Ui-Kits/Tooltip/Tooltip';
import Typography from '../../Pages/Ui-Kits/Typography';
import Charts from '../../Pages/Widgets/Charts/Charts';
import General from '../../Pages/Widgets/General/General';

type AppRoute = RouteObject & {
    permissions?: string[];
};

export const routes: AppRoute[] = [
    // dashboard
    { path: `${process.env.PUBLIC_URL}/`, element: <Ecommerce /> },
    { path: `${process.env.PUBLIC_URL}/dashboard/default`, element: <Default /> },
    { path: `${process.env.PUBLIC_URL}/dashboard/project`, element: <Project /> },

    // Widgets
    { path: `${process.env.PUBLIC_URL}/widgets/general`, element: <General /> },
    { path: `${process.env.PUBLIC_URL}/widgets/chart`, element: <Charts /> },

    // Page Layout
    {
        path: `${process.env.PUBLIC_URL}/pagelayout/hidenavscroll`,
        element: <HideNavScrollContainer />
    },

    // Applications
    { path: `${process.env.PUBLIC_URL}/project/projectlist`, element: <ProjectList /> },
    { path: `${process.env.PUBLIC_URL}/project/createnew`, element: <ProjectCreate /> },
    { path: `${process.env.PUBLIC_URL}/app/filemanager`, element: <FileManager /> },
    { path: `${process.env.PUBLIC_URL}/email/letterbox`, element: <LetterBox /> },
    { path: `${process.env.PUBLIC_URL}/chat/privatechats`, element: <PrivateChat /> },
    { path: `${process.env.PUBLIC_URL}/chat/groupchat`, element: <GroupChat /> },
    { path: `${process.env.PUBLIC_URL}/users/profile`, element: <UsersProfile /> },
    {
        path: `${process.env.PUBLIC_URL}/customers/detail`,
        element: <EditProfile user_type_id={'3'} />
    },
    {
        path: `${process.env.PUBLIC_URL}/customers/detail/:id`,
        element: <EditProfile user_type_id={'3'} />
    },
    { path: `${process.env.PUBLIC_URL}/customers`, element: <UserCards user_type_id={'3'} /> },
    {
        path: `${process.env.PUBLIC_URL}/suppliers/detail`,
        element: <EditProfile user_type_id={'2'} />
    },
    {
        path: `${process.env.PUBLIC_URL}/suppliers/detail/:id`,
        element: <EditProfile user_type_id={'2'} />
    },
    { path: `${process.env.PUBLIC_URL}/suppliers`, element: <UserCards user_type_id={'2'} /> },
    { path: `${process.env.PUBLIC_URL}/app/bookmark`, element: <Bookmark /> },
    { path: `${process.env.PUBLIC_URL}/app/contacts`, element: <Contacts /> },
    { path: `${process.env.PUBLIC_URL}/app/calender`, element: <Calender /> },
    { path: `${process.env.PUBLIC_URL}/app/task`, element: <Tasks /> },
    { path: `${process.env.PUBLIC_URL}/app/socialapp`, element: <SocialApp /> },
    { path: `${process.env.PUBLIC_URL}/app/todo`, element: <Todo /> },
    { path: `${process.env.PUBLIC_URL}/app/searchresult`, element: <SearchResult /> },

    // Ecommerce
    { path: `${process.env.PUBLIC_URL}/products/detail/:id`, element: <AddProduct /> },
    { path: `${process.env.PUBLIC_URL}/products/detail`, element: <AddProduct /> },
    { path: `${process.env.PUBLIC_URL}/products`, element: <ProductList /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/addproduct`, element: <AddProduct /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/products`, element: <Products /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/productpage`, element: <ProductPage /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/productlist`, element: <ProductList /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/paymentdetails`, element: <PaymentDetails /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/orderhistory`, element: <OrderHistory /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice1`, element: <InvoiceOne /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice2`, element: <InvoiceTwo /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice3`, element: <InvoiceThree /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice4`, element: <InvoiceFour /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice5`, element: <InvoiceFive /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice6`, element: <InvoiceSix /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, element: <Cart /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, element: <WishList /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, element: <Checkout /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, element: <Pricing /> },

    // Form Controls
    {
        path: `${process.env.PUBLIC_URL}/forms/formscontrols/formvalidation`,
        element: <FormsValidation />
    },
    { path: `${process.env.PUBLIC_URL}/forms/formscontrols/baseinput`, element: <BaseInput /> },
    {
        path: `${process.env.PUBLIC_URL}/forms/formscontrols/radiocheckbox`,
        element: <RadioCheckbox />
    },
    { path: `${process.env.PUBLIC_URL}/forms/formscontrols/inputgroups`, element: <InputGroup /> },
    { path: `${process.env.PUBLIC_URL}/forms/formscontrols/inputmask`, element: <InputMask /> },
    { path: `${process.env.PUBLIC_URL}/forms/formscontrols/megaoption`, element: <MegaOption /> },

    // Forms Widgets
    { path: `${process.env.PUBLIC_URL}/forms/formswidget/datepicker`, element: <DatePicker /> },
    { path: `${process.env.PUBLIC_URL}/forms/formswidget/touchspin`, element: <TouchSpin /> },
    { path: `${process.env.PUBLIC_URL}/forms/formswidget/switch`, element: <Switch /> },
    { path: `${process.env.PUBLIC_URL}/forms/formswidget/typeahead`, element: <Typeahead /> },
    { path: `${process.env.PUBLIC_URL}/forms/formswidget/clipboard`, element: <ClipBoard /> },

    // Form Layout
    { path: `${process.env.PUBLIC_URL}/forms/formslayout/formwizard1`, element: <FormWizardOne /> },
    { path: `${process.env.PUBLIC_URL}/forms/formslayout/formwizard2`, element: <FormWizardTwo /> },
    { path: `${process.env.PUBLIC_URL}/forms/formslayout/twofactor`, element: <TwoFactor /> },

    // Tables
    { path: `${process.env.PUBLIC_URL}/table/reactstraptable/basictable`, element: <BasicTable /> },
    {
        path: `${process.env.PUBLIC_URL}/table/reactstraptable/tablecomponent`,
        element: <TableComponent />
    },
    { path: `${process.env.PUBLIC_URL}/table/datatable/basicinit`, element: <BasicInit /> },
    { path: `${process.env.PUBLIC_URL}/table/datatable/advanceinit`, element: <AdvanceInit /> },
    { path: `${process.env.PUBLIC_URL}/table/datatable/api`, element: <ApiDataTable /> },
    { path: `${process.env.PUBLIC_URL}/table/datatable/datasources`, element: <DataSource /> },

    // Ui-Kits
    { path: `${process.env.PUBLIC_URL}/uikits/typography`, element: <Typography /> },
    { path: `${process.env.PUBLIC_URL}/uikits/avatars`, element: <Avatars /> },
    { path: `${process.env.PUBLIC_URL}/uikits/helperclass`, element: <HelperClasses /> },
    { path: `${process.env.PUBLIC_URL}/uikits/grid`, element: <Grid /> },
    { path: `${process.env.PUBLIC_URL}/uikits/tagpills`, element: <TagAndPills /> },
    { path: `${process.env.PUBLIC_URL}/uikits/progress`, element: <Progress /> },
    { path: `${process.env.PUBLIC_URL}/uikits/modal`, element: <Modal /> },
    { path: `${process.env.PUBLIC_URL}/uikits/alert`, element: <Alert /> },
    { path: `${process.env.PUBLIC_URL}/uikits/popover`, element: <Popover /> },
    { path: `${process.env.PUBLIC_URL}/uikits/tooltip`, element: <Tooltip /> },
    { path: `${process.env.PUBLIC_URL}/uikits/dropdown`, element: <Dropdown /> },
    { path: `${process.env.PUBLIC_URL}/uikits/accordion`, element: <Accordion /> },
    { path: `${process.env.PUBLIC_URL}/uikits/tabs`, element: <ReactstrapTabs /> },
    { path: `${process.env.PUBLIC_URL}/uikits/list`, element: <Lists /> },

    // Bonus Ui
    { path: `${process.env.PUBLIC_URL}/bonusui/scrollable`, element: <Scrollable /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/treeview`, element: <TreeView /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/toasts`, element: <Toast /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/rating`, element: <Rating /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/dropzone`, element: <Dropzone /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/tour`, element: <Tour /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/sweetalert2`, element: <SweetAlert /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/carousel`, element: <Carousel /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/ribbons`, element: <Ribbons /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/pagination`, element: <Pagination /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/breadcrumb`, element: <Breadcrumb /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/rangeslider`, element: <RangeSlider /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/imagecropper`, element: <ImageCropper /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/basiccards`, element: <BasicCard /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/creativecards`, element: <CreativeCard /> },
    { path: `${process.env.PUBLIC_URL}/bonusui/timeline`, element: <Timeline /> },

    // Buttons
    { path: `${process.env.PUBLIC_URL}/buttons/defaultstyle`, element: <DefaultStyle /> },
    { path: `${process.env.PUBLIC_URL}/buttons/buttongroup`, element: <ButtonGroup /> },

    // Icons
    { path: `${process.env.PUBLIC_URL}/icons/flagicons`, element: <FlagIcons /> },
    { path: `${process.env.PUBLIC_URL}/icons/fontawesomeicon`, element: <FontAwesomeIcon /> },
    { path: `${process.env.PUBLIC_URL}/icons/icoicon`, element: <ICOIcon /> },
    { path: `${process.env.PUBLIC_URL}/icons/themifyicon`, element: <ThemifyIcons /> },
    { path: `${process.env.PUBLIC_URL}/icons/feathericon`, element: <FeatherIcons /> },
    { path: `${process.env.PUBLIC_URL}/icons/whethericon`, element: <WhetherIcon /> },

    // Charts
    { path: `${process.env.PUBLIC_URL}/charts/apexchart`, element: <ApexChart /> },
    { path: `${process.env.PUBLIC_URL}/charts/googlechart`, element: <GoogleChart /> },
    { path: `${process.env.PUBLIC_URL}/charts/chartjschart`, element: <ChartJs /> },

    // Sample Page
    { path: `${process.env.PUBLIC_URL}/pages/samplepage`, element: <SamplePage /> },

    // Gallery
    { path: `${process.env.PUBLIC_URL}/gallery/gallerygrids`, element: <GalleryGrid /> },
    { path: `${process.env.PUBLIC_URL}/gallery/gallerygriddesc`, element: <GalleryGridDesc /> },
    { path: `${process.env.PUBLIC_URL}/gallery/masonrygallery`, element: <MasonryGallery /> },
    { path: `${process.env.PUBLIC_URL}/gallery/masonrywithdesc`, element: <MasonryImageDesc /> },
    { path: `${process.env.PUBLIC_URL}/gallery/hovereffect`, element: <HoverEffect /> },

    // Blog
    { path: `${process.env.PUBLIC_URL}/blog/blogdetails`, element: <BlogDetails /> },
    { path: `${process.env.PUBLIC_URL}/blog/blogsingle`, element: <BlogSingle /> },
    { path: `${process.env.PUBLIC_URL}/blog/addpost`, element: <AddPost /> },

    // Faq
    { path: `${process.env.PUBLIC_URL}/faq/faq`, element: <Faq /> },

    // Job Search
    { path: `${process.env.PUBLIC_URL}/jobsearch/cardview`, element: <CardView /> },
    { path: `${process.env.PUBLIC_URL}/jobsearch/listview`, element: <ListView /> },
    { path: `${process.env.PUBLIC_URL}/jobsearch/jobdetail`, element: <JobDetails /> },
    { path: `${process.env.PUBLIC_URL}/jobsearch/apply`, element: <JobApply /> },

    // Learning
    { path: `${process.env.PUBLIC_URL}/learning/learninglist`, element: <LearningList /> },
    { path: `${process.env.PUBLIC_URL}/learning/detailcourse`, element: <DetailsCourse /> },

    // Maps
    { path: `${process.env.PUBLIC_URL}/map/googlemap`, element: <GoogleMap /> },
    { path: `${process.env.PUBLIC_URL}/map/leafletmap`, element: <LeafletMaps /> },

    // Editors
    { path: `${process.env.PUBLIC_URL}/editor/ckeditor`, element: <CkEditor /> },
    { path: `${process.env.PUBLIC_URL}/editor/mdeeditor`, element: <MdeEditor /> },
    { path: `${process.env.PUBLIC_URL}/editor/aceeditor`, element: <AceEditor /> },

    // Knowledgebase
    { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`, element: <Knowledgebase /> },

    // SupportTicket
    { path: `${process.env.PUBLIC_URL}/supportticket/supportticket`, element: <SupportTicket /> }
];
